package navigation.settings.categories

import navigation.settings.categories.allcategories.AllCategoriesScreenModel
import navigation.settings.categories.addeditcategory.AddEditCategoryScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val categoryUiModule
    get() =
        module {
            factoryOf(::AllCategoriesScreenModel)
            factoryOf(::AddEditCategoryScreenModel)
        }